import BaseApiCall from "./BaseApiCall";

export const loadAdminList = async () => {
  try {
    const response = await BaseApiCall.post("/admin-settings/load-admin");
    return response;
  } catch (error) {
    console.error('Error loading dept:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
}

export const loadUser = async () => {
  try {
    const response = await BaseApiCall.post("/au/load-user");
    return response;
  } catch (error) {
    console.error('Error loading dept:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
}

export const getOrganizationSettings = async () => {
  try {
    const response = await BaseApiCall.get("/admin-settings/get-organization-settings");
    return response;
  } catch (error) {
    console.error('Error loading dept:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
}
export const saveOrganizationSettings = async (payload) => {
  try {
    const response = await BaseApiCall.post("/admin-settings/save-organization-settings", payload);
    return response;
  } catch (error) {
    console.error('Error loading dept:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
}

export const loadAdminUserForm = async () => {
  try {
    const response = await BaseApiCall.post('/au/admin-user-form');
    return response;
  } catch (error) {
    throw error;
  }
};

export const submitAdminUser = async (payload) => {
  try {
    const response = await BaseApiCall.post('/au/add-admin-user', payload);
    return response;
  } catch (error) {
    throw error;
  }
}

export const loadUserForm = async () => {
  try {
    const response = await BaseApiCall.post('/au/user-form');
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchUserForm = async (userId) => {
  const response = await BaseApiCall.get(`/au/user-form/${userId}`);
  return response.data;
};

export const updateUser = async (payload) => {
  try {
    const response = await BaseApiCall.put(`/au/update-user/${payload.id}`, payload);
    return response;
  } catch (error) {
    throw error;
  }
}

export const submitUser = async (payload) => {
  try {
    const response = await BaseApiCall.put('/au/add-user', payload);
    return response;
  } catch (error) {
    throw error;
  }
}

export const addTicketProgressStatus = async (formData) => {
  try {
    const response = await BaseApiCall.post('/admin-settings/new-ticket-progress-status', formData);
    return response;
  } catch (error) {
    console.error('Error loading dept:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
}

export const loadTicketHead = async () => {
  try {
    const response = await BaseApiCall.post('/dy/load-ticket-head');
    return response;
  } catch (error) {
    console.error('Error loading dept:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};

export const loadCustomerForm = async () => {
  try {
    const response = await BaseApiCall.post('/dy/load-customer-form');
    return response;
  } catch (error) {
    console.error('Error loading dept:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
}

export const loadTicketsDynamicForm = async (ticketHeadId) => {
  try {
    const response = await BaseApiCall.post('/settings/dy-form-by-ticket-head', ticketHeadId);
    return response;
  } catch (error) {
    console.error('Error loading dept:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};

export const loadApiEndPoint = async (dyFormId, fieldLabel) => {
  try {
    const params = new URLSearchParams({ dyFormId, formLabel: fieldLabel });
    const response = await BaseApiCall.post(`/admin-settings/get-api-endpoint?${params.toString()}`);
    return response;
  } catch (error) {
    console.error('Error loading dept:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
}

export const saveApiEndpoint = async (payload) => {
  try {
    const response = await BaseApiCall.post("/admin-settings/save-endpoint", payload);
    return response;
  } catch (error) {
    console.error('Error loading dept:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
}

export const loadProviderSettings = async () => {
  try {
    const response = await BaseApiCall.post('/suadmin/load-provider-settings');
    return response;
  } catch (error) {
    console.error('Error loading organization:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
}

export const getProviderSettingsByOrg = async (organizationId) => {
  try {
    const response = await BaseApiCall.post('/suadmin/provider-settings-by-organization', { id: organizationId });
    return response;
  } catch (error) {
    console.error('Error loading organization:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
}

export const saveProviderSettings = async (payload) => {
  try {
    const response = await BaseApiCall.post('/suadmin/save-provider-settings', payload);
    return response;
  } catch (error) {
    console.error('Error loading organization:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
}

export const loadSmsTriggerEvent = async () => {
  try {
    const response = await BaseApiCall.get('/sms-event-settings/load');
    return response;
  } catch (error) {
    throw error;
  }
};

export const getNewSmsEventForm = async (id = null) => {
  try {
    const response = await BaseApiCall.get('/sms-event-settings/form', { params: id ? { id } : {} });
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveSmsEvent = async (payload) => {
  try {
    const response = await BaseApiCall.post('/sms-event-settings/add', payload);
    return response;
  } catch (error) {
    throw error;
  }
};